require('../bootstrap');
require('./sliders');
require('./countdown');
require('./select2');
require('./datepicker');
require('./custom');
